'use client';

var __jsx = React.createElement;
import React from 'react';
import { useLanguageConfig } from '@lib/context/shared/lang-context';
import Icons from '@modules/icons';
import useCssModules from '@lib/hooks/use-css-modules';
const FooterLangButton = () => {
  var _cssModules$footers$f;
  const langConfig = useLanguageConfig();
  const {
    cssModules
  } = useCssModules();
  const {
    languageButtonClassNames,
    languageButtonIconClassNames
  } = (_cssModules$footers$f = cssModules === null || cssModules === void 0 ? void 0 : cssModules.footers.footerDefault) !== null && _cssModules$footers$f !== void 0 ? _cssModules$footers$f : {};
  return __jsx("button", {
    className: languageButtonClassNames
  }, __jsx("div", {
    className: "flex items-center gap-2"
  }, __jsx(Icons.globe, {
    className: languageButtonIconClassNames
  }), "".concat(langConfig.currentLanguage, " (").concat(langConfig.currentLanguageCode.toUpperCase(), ")")));
};
export default FooterLangButton;